import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74eba255"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toast-message__icon" }
const _hoisted_2 = { class: "toast-message__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_icon = _resolveComponent("base-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: _ctx.relativeTo }, [
    _createVNode(_Transition, { name: "appear" }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["toast-message", `toast-message--${_ctx.type}`])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_base_icon, {
                  width: "4rem",
                  height: "4rem",
                  fill: "#fff",
                  icon: _ctx.iconType
                }, null, 8, ["icon"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("header", null, [
                  _renderSlot(_ctx.$slots, "title", {}, () => [
                    _createTextVNode("Title")
                  ], true)
                ]),
                _createElementVNode("p", null, [
                  _renderSlot(_ctx.$slots, "default", {}, () => [
                    _createTextVNode("Description")
                  ], true)
                ])
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 8, ["to"]))
}